
import { ReactNode, Suspense, startTransition } from 'react';
import { Loader } from '@/components/ui/loader';
import { useChatServices } from '@/hooks/chat/useChatServices';
import { ChatAgentContextProvider } from './ChatAgentContext';

interface ChatAgentProviderProps {
  children: ReactNode;
}

export const ChatAgentProvider = ({ children }: ChatAgentProviderProps) => {
  const { agents, isLoadingAgents } = useChatServices();

  // If agents are still loading, show a loading state
  if (isLoadingAgents) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <Loader size={32} text="Loading agents..." />
      </div>
    );
  }

  return (
    <ChatAgentContextProvider agents={agents} isLoadingAgents={isLoadingAgents}>
      <Suspense fallback={
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <Loader size={32} text="Loading chat services..." />
        </div>
      }>
        {children}
      </Suspense>
    </ChatAgentContextProvider>
  );
};
